<template>
  <div class="encryption-field">
    <div style="display: flex; align-items: center;">
      <span style="font-weight: bold">{{ displayValue }}</span>
      <span
        v-if="hasValue"
        class="iconEye"
        :class="{ 'is-loading': loading }"
        @click="toggleDecrypt"
      >
        <el-tooltip placement="top-start">
          <div slot="content">{{ $t('GlobalSetObj.completionInformation') }}</div>
          <svg-icon :icon-class="iconType" />
        </el-tooltip>
      </span>
    </div>
  </div>
</template>

<script>
import { sensitiveViewPlaintext } from '@/api/user';

export default {
  name: 'EncryptionField',
  props: {
    fieldName: {
      type: String,
      required: true
    },
    encryptedValue: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      required: true
    },
    apiParams: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      decryptedValue: '', // 解密后的数据（缓存）
      isDecrypted: false, // 当前是否显示解密状态
      loading: false
    };
  },
  computed: {
    hasValue() {
      return !!this.encryptedValue;
    },
    displayValue() {
      // 如果当前是显示状态且有解密数据
      if (this.isDecrypted && this.decryptedValue) {
        return this.decryptedValue;
      }
      // 如果为空字符串
      if (!this.encryptedValue) {
        return '--';
      }
      // 默认显示 ********
      return '********';
    },
    iconType() {
      if (this.loading) {
        return 'loading';
      }
      // 显示状态用 iconEyeOpen，隐藏状态用 iconEye
      return 'iconEye';
    }
  },
  methods: {
    async toggleDecrypt() {
      // 如果正在加载，防止重复请求
      if (this.loading) {
        return;
      }

      // 如果已经是显示状态，直接隐藏
      if (this.isDecrypted) {
        this.isDecrypted = false;
        this.$emit('hidden', { fieldName: this.fieldName });
        return;
      }

      // 如果有缓存的解密数据，直接显示
      if (this.decryptedValue) {
        this.isDecrypted = true;
        this.$emit('shown', {
          fieldName: this.fieldName,
          value: this.decryptedValue
        });
        return;
      }

      // 否则请求解密接口
      try {
        this.loading = true;

        const params = {
          data: {
            [this.fieldName]: this.encryptedValue,
            ...this.apiParams
          }
        };

        const response = await sensitiveViewPlaintext(params);

        // 保存解密数据（缓存）
        this.decryptedValue = response.data[this.fieldName] || response;
        this.isDecrypted = true;

        // 触发事件，通知父组件
        this.$emit('decrypted', {
          fieldName: this.fieldName,
          value: this.decryptedValue
        });
      } catch (error) {
        console.error('解密失败:', error);
        // this.$message.error(this.$t('decryptFailed') || '解密失败');
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.encryption-field {
  .iconEye {
    margin-left: 8px;
    cursor: pointer;
    color: #409EFF;
    transition: all 0.3s;

    &:hover {
      color: #66b1ff;
      transform: scale(1.1);
    }

    &.is-loading {
      cursor: not-allowed;
      opacity: 0.6;
      animation: rotating 1s linear infinite;
    }
  }
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
